var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cooperationView" },
    [
      _c("div", { staticClass: "flex" }, [
        _vm._m(0),
        _c(
          "div",
          { staticClass: "content-style" },
          [
            _c("div", { staticClass: "title-style" }, [_vm._v("合作关系")]),
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.scholarCoLoading,
                    expression: "scholarCoLoading",
                  },
                ],
                ref: "multipleTable",
                staticStyle: { width: "100%" },
                attrs: {
                  "header-cell-style": {
                    background: "#F4F7F9",
                    borderBottom: "1px solid #E3EEF5",
                    color: "#333333",
                    fontSize: "14px",
                    fontWeight: "500",
                    width: "100%",
                  },
                  data: _vm.scholarCoData,
                  "tooltip-effect": "dark",
                },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "name", label: "专家姓名" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "person-name" }, [
                            _vm._v(_vm._s(scope.row.name)),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { prop: "org", label: "所属机构" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex-column overflow overflow-2 person-org",
                            },
                            [_vm._v(" " + _vm._s(scope.row.org) + " ")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { prop: "honors", label: "荣誉头衔" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "flex items-center",
                              staticStyle: { "min-height": "46px" },
                            },
                            [
                              scope.row.honors != null &&
                              scope.row.honors.length > 0
                                ? _c(
                                    "div",
                                    { staticClass: "flex flex-wrap" },
                                    _vm._l(
                                      scope.row.honors,
                                      function (item, index) {
                                        return _c(
                                          "p",
                                          {
                                            key: index,
                                            staticStyle: { color: "#1241C9" },
                                          },
                                          [
                                            index != 0
                                              ? _c("span", [_vm._v("、")])
                                              : _vm._e(),
                                            _vm._v(" " + _vm._s(item) + " "),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _c("p", [_vm._v("-")]),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { prop: "coType", label: "合作方式" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("p", {
                            staticClass: "pre-wrap",
                            staticStyle: { color: "#f39800" },
                            domProps: { innerHTML: _vm._s(scope.row.coType) },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { prop: "coTimes", label: "合作次数" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "p",
                            {
                              staticStyle: {
                                color: "#344054",
                                cursor: "pointer",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.shouDialog(scope.row)
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(scope.row.coTimes) + "次 ")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _vm.scholarCoData && _vm.scholarCoData.length
              ? _c(
                  "div",
                  { staticClass: "page-container" },
                  [
                    _c("el-pagination", {
                      attrs: {
                        background: "",
                        "current-page": _vm.scholarCoData.pageNo + 1,
                        "page-size": _vm.scholarCoData.pageSize,
                        "page-sizes": [10, 20, 50, 100],
                        layout: "sizes,prev, pager, next",
                        total: _vm.totalElements,
                      },
                      on: {
                        "current-change": _vm.handleCurrentChange,
                        "size-change": _vm.handleSizeChange,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "flex" }, [
        _vm._m(1),
        _c("div", { staticClass: "content-style" }, [
          _c("div", { staticClass: "title-style flex justify-between" }, [
            _vm._v(" 科研图谱 "),
            _c(
              "div",
              { staticClass: "graph-input flex items-center justify-end" },
              [
                _c(
                  "el-input",
                  {
                    staticStyle: { width: "240px" },
                    attrs: { placeholder: "输入人名或者机构名称" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.getScholarRelation.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.graphInput,
                      callback: function ($$v) {
                        _vm.graphInput = $$v
                      },
                      expression: "graphInput",
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "el-input__icon el-icon-search",
                      attrs: { slot: "prefix" },
                      slot: "prefix",
                    }),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "city-div" },
                  [
                    _c("el-cascader", {
                      staticStyle: {
                        "margin-left": "10px",
                        "font-size": "16px",
                      },
                      attrs: {
                        placeholder: "所在地",
                        options: _vm.cityList,
                        props: {
                          expandTrigger: "hover",
                          value: "regionName",
                          label: "regionName",
                        },
                      },
                      on: { change: _vm.clickGraphCheckChange },
                      model: {
                        value: _vm.cityValue,
                        callback: function ($$v) {
                          _vm.cityValue = $$v
                        },
                        expression: "cityValue",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c("div"),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.graphLoading,
                  expression: "graphLoading",
                },
              ],
            },
            [
              _c(
                "div",
                { staticClass: "flex items-center graph-select justify-end" },
                [
                  _c(
                    "div",
                    { staticClass: "flex items-center" },
                    [
                      _c(
                        "div",
                        { staticClass: "flex" },
                        [
                          _c("el-checkbox", {
                            model: {
                              value: _vm.showEdge,
                              callback: function ($$v) {
                                _vm.showEdge = $$v
                              },
                              expression: "showEdge",
                            },
                          }),
                          _c("p", { staticClass: "select-text" }, [
                            _vm._v("查看合作次数"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "p",
                        {
                          staticClass: "select-text",
                          staticStyle: { "font-size": "16px" },
                        },
                        [_vm._v("节点数")]
                      ),
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择" },
                          on: { change: _vm.clickGraphChange },
                          model: {
                            value: _vm.graphValue,
                            callback: function ($$v) {
                              _vm.graphValue = $$v
                            },
                            expression: "graphValue",
                          },
                        },
                        _vm._l(_vm.graphOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm.graphData != null && _vm.graphData.nodes.length > 0
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        width: "100%",
                        height: "600px",
                        position: "relative",
                      },
                    },
                    [
                      _c("relational-graph", {
                        attrs: {
                          "graph-data": _vm.graphData,
                          id: "co-author",
                          force: _vm.force,
                          showEdge: _vm.showEdge,
                        },
                        on: { graphClick: _vm.graphClick },
                      }),
                    ],
                    1
                  )
                : _c("el-empty", { attrs: { height: 600 } }),
            ],
            1
          ),
        ]),
      ]),
      _c("achievement-dialog", {
        ref: "achievementDialog",
        attrs: { "scholar-id": _vm.scholarId, "or-scholar-id": _vm.clickId },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticStyle: { width: "24px" } }, [
      _c("div", { staticClass: "border-bg" }, [_c("div")]),
      _c("div", { staticClass: "line-bg" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticStyle: { width: "24px" } }, [
      _c("div", { staticClass: "border-bg" }, [_c("div")]),
      _c("div", { staticClass: "line-bg" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }